export default Object.freeze({
  Search: 'search',
  Add: 'add',
  Modify: 'modify',
  Remove: 'remove',
  Count: 'count',
  Sum: 'sum',
  Subtraction: 'subtraction',
  Increment: 'increment',
  Decrement: 'decrement',
  EvaluateFormula: 'evaluate-formula',
});
